import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//预览组件
import { useState } from "react";
import { Button, message } from "antd";
import styles from "./index.module.less";
import classNames from "classnames";
import PdfPreview from "../PdfPreview";
import { UploadAttachmentCv } from "@/services/resume";
import WordPreview from "../WordPreview";
import { useLocale } from "@/hooks/useLocale";
import { globalEventBus } from "@/utils/globalEvent";
const MAX_FILE_SIZE_MB = 20;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const Previewer = ({ uploadFiles, clearFiles, reloadData, isLink, fileType, linkFiles, isChatMessage, customMessage, isUpload, showDownload, locale, submitCallback, }) => {
    const { t } = useLocale("attachmentResume", locale);
    const [uploading, setUploading] = useState(false);
    //重新上传
    const handleReUpload = () => {
        clearFiles();
    };
    //上传
    const handleUpload = async () => {
        try {
            const formData = new FormData();
            if (uploadFiles.length === 0 || uploading)
                return;
            // 再次检查文件大小
            const oversizedFiles = uploadFiles.filter((f) => f.file.size > MAX_FILE_SIZE_BYTES);
            if (oversizedFiles.length > 0) {
                message.error(t("attachmentNotOver20"));
                return;
            }
            uploadFiles.forEach((f, index) => {
                formData.append("file_" + index + 1, f.file);
            });
            setUploading(true);
            const resp = await UploadAttachmentCv(formData);
            if (resp?.code === 0) {
                message.success(t("uploadSuccess"));
                reloadData?.();
                clearFiles();
                submitCallback?.();
                globalEventBus.emit("refreshResume", () => {
                    return true;
                });
            }
            else {
                message.error(t("uploadFail"));
            }
        }
        catch (e) {
            message.error(t("uploadFail"));
        }
        finally {
            setUploading(false);
        }
    };
    // 根据URL或传入的fileType确定文件类型
    const getFileType = () => {
        if (fileType)
            return fileType;
        let url = "";
        if (isLink) {
            url = linkFiles?.[0]?.url;
        }
        if (isUpload) {
            return uploadFiles?.[0]?.type;
        }
        if (isChatMessage) {
            url = customMessage?.urls?.[0];
        }
        const extension = url?.split(".").pop()?.toLowerCase();
        if (["jpg", "jpeg", "png"].includes(extension || ""))
            return "image";
        if (extension === "pdf")
            return "pdf";
        if (extension === "doc")
            return "doc";
        return "docx";
    };
    const getFileName = () => {
        let fileName = "";
        if (isUpload) {
            fileName = uploadFiles?.[0]?.file?.name;
        }
        if (isLink) {
            console.log(linkFiles);
            fileName = linkFiles[0]?.fileName;
        }
        if (isChatMessage) {
            console.log(customMessage);
            fileName = customMessage?.fileName;
        }
        return fileName;
    };
    const getFileSize = () => {
        let fileSize = "";
        if (isUpload) {
            console.log(uploadFiles);
            fileSize = uploadFiles?.[0]?.file?.size
                ? (uploadFiles?.[0]?.file?.size / 1024 / 1024).toFixed(2)
                : "--";
        }
        if (isLink) {
            console.log(linkFiles);
            let size = 0;
            linkFiles?.map((item) => {
                size += item?.size;
            });
            fileSize = size ? (size / 1024 / 1024).toFixed(2) : "--";
        }
        if (isChatMessage) {
            fileSize = customMessage?.size
                ? (customMessage?.size / 1024 / 1024).toFixed(2)
                : "--";
        }
        return fileSize;
    };
    // 下载文件
    const downloadFile = (fileName, link) => {
        const links = document.createElement("a");
        links.href = link;
        links.download = fileName || "CV.pdf";
        links.target = "_blank";
        document.body.appendChild(links);
        links.click();
        document.body.removeChild(links);
    };
    // 处理下载事件
    const handleDownload = () => {
        if (isChatMessage) {
            customMessage?.urls?.forEach((item) => {
                downloadFile(customMessage?.fileName, item);
            });
        }
        if (isLink) {
            linkFiles?.forEach((item) => {
                downloadFile(item?.fileName, item?.url);
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classNames(styles.cvUploaderWrapperPreview), children: [_jsx("div", { className: classNames(styles.cvUploaderWrapperPreviewLeft), children: _jsxs("div", { className: classNames(styles.cvUploaderWrapperPreviewLeftContent), children: [isUpload &&
                                    uploadFiles?.map((file, index) => {
                                        switch (file.type) {
                                            case "image":
                                                return _jsx("img", { src: file.preview, alt: "" }, index);
                                            case "pdf":
                                                return (_jsx("div", { className: classNames(styles.cvUploaderWrapperPreviewLeftPdf), children: _jsx(PdfPreview, { fileUrl: file.preview, locale: locale }, index) }, index));
                                            case "doc":
                                                return (_jsx("div", { className: styles.notSupport, children: t("notSupportPreviewDoc") }, index));
                                            case "docx":
                                                return (_jsx("div", { children: _jsx(WordPreview, { url: file.preview, locale: locale }, index) }));
                                            default:
                                                return (_jsx("div", { className: styles.notSupport, children: t("chat.notSupportPreviewType") }, index));
                                        }
                                    }), isLink &&
                                    linkFiles?.map((file, index) => {
                                        switch (getFileType()) {
                                            case "image":
                                                return _jsx("img", { src: file?.url, alt: "" }, index);
                                            case "pdf":
                                                return (_jsx("div", { className: classNames(styles.cvUploaderWrapperPreviewLeftPdf), children: _jsx(PdfPreview, { fileUrl: file?.url, locale: locale }, index) }, index));
                                            case "doc":
                                                return (_jsx(WordPreview, { url: file?.url, locale: locale }, index));
                                            case "docx":
                                                return (_jsx(WordPreview, { url: file?.url, locale: locale }, index));
                                            default:
                                                return (_jsx("div", { className: styles.notSupport, children: t("chat.notSupportPreviewType") }, index));
                                        }
                                    }), isChatMessage &&
                                    customMessage?.urls?.map((file, index) => {
                                        switch (getFileType()) {
                                            case "image":
                                                return _jsx("img", { src: file, alt: "" }, index);
                                            case "pdf":
                                                return (_jsx("div", { className: classNames(styles.cvUploaderWrapperPreviewLeftPdf), children: _jsx(PdfPreview, { fileUrl: file, locale: locale }, index) }, index));
                                            case "doc":
                                                return (_jsx(WordPreview, { url: file, locale: locale }, index));
                                            case "docx":
                                                return (_jsx(WordPreview, { url: file, locale: locale }, index));
                                            default:
                                                return (_jsx("div", { children: t("chat.notSupportPreviewType") }, index));
                                        }
                                    })] }) }), _jsx("div", { className: classNames(styles.cvUploaderWrapperPreviewRight), children: _jsxs("div", { className: classNames(styles.cvUploaderWrapperPreviewRightBox), children: [_jsxs("div", { children: [_jsx("span", { className: "", children: t("attachmentResumeName") }), _jsx("span", { className: "", children: getFileName() })] }), _jsxs("div", { children: [_jsx("span", { className: "", children: t("attachmentResumeSize") }), _jsxs("span", { className: "", children: [getFileSize(), "MB"] })] }), _jsxs("div", { children: [_jsx("span", { className: "", children: t("attachmentResumeType") }), _jsx("span", { className: "", children: getFileType() })] })] }) })] }), _jsxs("div", { className: classNames(styles.cvUploaderActions), children: [uploadFiles?.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Button, { type: "default", disabled: uploading, className: classNames(styles.uploadBtn), onClick: handleReUpload, children: t("reUpload") }), _jsx(Button, { loading: uploading, type: "primary", className: classNames(styles.uploadBtn, styles.primary), onClick: handleUpload, children: t("upload") })] })), showDownload && (_jsx(Button, { loading: uploading, type: "primary", className: styles.primary, onClick: handleDownload, children: t("downloadFile") }))] })] }));
};
export default Previewer;
